import events_mtq_dokumen from'./../views/EVENTS/MTQ/dokumen.vue'
import events_mtq_gallery_foto from'./../views/EVENTS/MTQ/gallery_foto.vue'
import events_mtq_gallery_video from'./../views/EVENTS/MTQ/gallery_video.vue'



function loggedInRedirectDashboard(to, from, next) {
    if (localStorage.token) {
      next('/dashboard');
    } else {
      next();
    }
  }
  
  function isLoggedIn(to, from, next) {
    if (localStorage.token) {
      next();
    } else {
      next('/monev_login');
    }
  }
  
  var routes = [

      {
        path: '/events_mtq_dokumen',
        name: 'events_mtq_dokumen',
        component: events_mtq_dokumen,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/events_mtq_gallery_foto',
        name: 'events_mtq_gallery_foto',
        component: events_mtq_gallery_foto,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/events_mtq_gallery_video',
        name: 'events_mtq_gallery_video',
        component: events_mtq_gallery_video,
        beforeEnter: isLoggedIn,
      },


  
  ]



  export default routes